import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  	name:'name',
  	footerData:{audioData:{total:'00:00',current:'00:00',percentage:0,icon:'icon-bofang',text:''},page:1,type:'culture'}
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
